import {
  initializeSuccess,
  changeLocation,
  clickHeaderButton,
} from '../actions';
import { TRACK_IDENTIFY, TRACK_PAGE } from '../constants';
import { extractPathAndHash } from '../utils/url';
import type { RootState } from '../reducers';
import type { InitializeSuccessPayload } from '../shared/types';

export interface TrackEvent {
  eventName: string;
  eventPayload?: Record<string, unknown>;
}

// map redux actions to user tracking events.
// NOTE: this map supports only ONE event per action type (the tracker middleware
// looks up `mapping[action.type]`). `app_shell_loaded` is therefore fired for
// INITIALIZE_SUCCESS from `appShellLoadedFx` in src/effects/index.ts — do not add
// a second `[initializeSuccess.type]` entry here or it will silently overwrite
// this one (that regression dropped identify from 2025-03-27, PR #757).
export default {
  [initializeSuccess.type]: (
    state: RootState,
    { myAccountData: { id }, currentMerchantData }: InitializeSuccessPayload
  ): TrackEvent => ({
    eventName: TRACK_IDENTIFY,
    eventPayload: {
      id,
      data: {
        'Merchant uuid': currentMerchantData.id,
        'Merchant account uuid': id,
        id,
      },
    },
  }),
  [changeLocation.type]: (
    state: RootState,
    { url }: { url: string }
  ): TrackEvent => ({
    eventName: TRACK_PAGE,
    eventPayload: {
      properties: {
        path: extractPathAndHash(url),
        url,
      },
    },
  }),
  [clickHeaderButton.type]: (state: RootState, name: string): TrackEvent => ({
    eventName: `header_${name}_click`,
  }),
};
